// Code modules are custom modules built on the `python_code` transform.
export const CODE_MODULE = 'python_code';

export const isCodeModule = (mod) => mod?.source === 'custom' && mod?.module_name === CODE_MODULE;

// Config for a node dropped from a palette entry. Code modules are linked by id
// (editing the module changes every pipeline that uses it); saved presets are copied.
export const initialNodeConfig = (moduleName, customModuleId, presetConfig) => {
  if (moduleName === CODE_MODULE && customModuleId) {
    return { code_module_id: customModuleId, params: {} };
  }
  return { ...(presetConfig || {}) };
};
